import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
//import { useParams } from 'react-router-dom'

import { Panel } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import CenterAddBankAccountForm from './CenterAddBankAccountForm'
import CenterAddBankAccountView from './CenterAddBankAccountView'
import { getBankAccount, saveBankAccount } from '../../redux/actions/contract'
import { startLoading, doneLoading } from '../../utils/loading'
import ButtonPanel from '../../widgets/ButtonPanel'
import notification from '../../utils/notification'
import { SAVE_FAILED_MSG, SAVE_SUCCESS_MSG } from '../../constants/msgText'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'

export default function CenterAddBankAccountWidget(props) {
  const { showCommandButton, isSave } = props
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(props.schema)
  const [showSuccess, setShowSuccess] = useState(false)
  const [isEdit, setIsEdit] = useState(false)

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const handleCallService = async (request, projectVersionId) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    setShowSuccess(false)
    try {
      let response = await saveBankAccount(request, projectVersionId)
      console.log('response', response)
      if (response.success) {
        setFormSchema(response.model.forms)
        setIsEdit(false)
        setIsError(false)
        isSave(true)
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
        })
      }
    } catch (e) {
      console.log('error => ', e)
      notification.open('error', {
        title: e?.response?.data?.errorMessage || SAVE_FAILED_MSG,
      })
      if (e?.response?.data) {
        setIsError(e.response.data.errors?.message)
      } else {
        setIsError(true)
      }
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('data', data)

    const bankName = formSchema?.bankName?.options?.find((e) => e.value == data.bankName) || ''
    const bankBranch =
      formSchema?.bankBranch?.options?.find((e) => e.value == data.bankBranch) || ''

    let request = {
      bankCode: data.bankName || '',
      bankName: bankName.label || '',
      bankBranch: bankBranch.label || '',
      bankAccountNumber: data.bankAccountNumber,
      bankAccountName: data.bankAccountName,
      bankBranchCode: data.bankBranch,
      bankAccountType: data.bankAccountType,
    }

    // console.log('request', request)

    handleCallService(request, projectId)
  }

  const handleGetSchema = async () => {}

  const handleChangeGetBankBranch = async (bankCode) => {
    console.log('handleChangeGetBankBranch => ', bankCode)
    setIsLoading(true)
    startLoading()
    try {
      const response = await getBankAccount(projectId, bankCode)
      console.log('response => ', response.model)
      setFormSchema(response.model.forms)
      // setSchema(response.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
      style={{ marginBottom: 20 }}
    >
      {isLoading && <OverlayLoader />}

      {isEdit && showCommandButton ? (
        <CenterAddBankAccountForm
          schema={formSchema}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          setValue={setValue}
          clearErrors={clearErrors}
          changeGetBankBranch={handleChangeGetBankBranch}
        />
      ) : (
        <CenterAddBankAccountView schema={formSchema} />
      )}

      {showCommandButton && (
        <>
          <hr />
          <ButtonPanel
            isDisabled={isLoading}
            isEdit={isEdit}
            isError={isError}
            buttonText={formSchema.buttonText}
            onSave={handleSubmit(onSubmit)}
            onCancel={() => {
              setIsError(false)
              setIsEdit(!isEdit)
            }}
            onEdit={() => {
              setIsError(false)
              setIsEdit(!isEdit)
            }}
          />
        </>
      )}
    </Panel>
  )
}
